const initproductItems = () => {

	const product = document.querySelectorAll('.single-product');



	product.forEach(section => {
		let sectionSwiper = section.querySelector('.product__swiper');
		if (sectionSwiper) {
			sectionSwiper = sectionSwiper.className.split(' ')[1];
		}
		if (!sectionSwiper) {
			return false;
		}
		const swiper = new Swiper(`.${sectionSwiper}`, {
			slidesPerView: 'auto',
			spaceBetween: 24,
			centeredSlides: true,
			grabCursor: true,
			scrollbar: {
				draggable: true,
				el: '.swiper-scrollbar',
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				768: {
					centeredSlides: false,
				}
			}
		});
	});
}
window.addEventListener('DOMContentLoaded', () => {
	initproductItems();
});